import { getSessionIdToken } from '../auth/apiAuth'
import axios from 'axios';
const INTEGRATIONS_ENDPOINT = `${process.env.REACT_APP_API_BASE_URL}/integrations`;


//metodo per il fetch delle integrazioni di un progetto
export const fetchIntegrations = async (setError, projectValue) => {
    const [customer, project_name] = projectValue.split('/').slice(0, 2);

    setError(null);

    try {
        const response = await axios.get(INTEGRATIONS_ENDPOINT, {
            headers: {
                'customer': customer,
                'project_name': project_name,
                "Authorization": await getSessionIdToken(),
                'content-type': 'application/json',
            }
        });
        const data = response.data.services || [];
        return data;
    } catch (err) {
        setError("An error occurred. Please retry again.");
        return null;
    }
};


// metodo per l'autenticazione di Plytix per ottenere l'access_token
export const fetchPlytixBearerToken = async (setError, api_key, api_pass) => {
    try {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "api_key": api_key,
            "api_password": api_pass
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        const res = await fetch("https://auth.plytix.com/auth/api/get-token", requestOptions)
            .then(response => response.text())
            .then(result => { return result })
        const data = JSON.parse(res).data[0] || null
        if (data) {
            return data.access_token
        }
        else {
            setError("An error occurred with the Plytix authentication. Please retry again.");
            return null
        }
    } catch (err) {
        setError("An error occurred with the Plytix authentication. Please retry again.");
        return null
    }
}